module.exports = __webpack_public_path__ + "img/testimonials-badge.1b9f671b.svg";